/**
 * Normalise a user-typed link into a safe href, or `null` when it can't be
 * made into one. Body links are restricted to `https` / `mailto` (the backend
 * sanitiser denies plain `http`), so `http://` is upgraded to `https://`,
 * scheme-less input is assumed `https://`, and a bare email becomes `mailto:`.
 */
export function normalizeLinkUrl(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) return null;

  if (/^mailto:/i.test(trimmed)) return trimmed;
  if (/^https:\/\//i.test(trimmed)) return trimmed;
  // Upgrade http → https so the link survives body sanitisation.
  if (/^http:\/\//i.test(trimmed)) {
    return trimmed.replace(/^http:\/\//i, "https://");
  }

  // Looks like a bare email address → mailto.
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) return `mailto:${trimmed}`;

  // Looks like a domain / path → assume https.
  if (/^[^\s]+\.[^\s]+/.test(trimmed)) return `https://${trimmed}`;

  return null;
}

/** A short, human-friendly version of an href for display in the toolbar. */
export function prettyLinkLabel(href: string): string {
  return href.replace(/^mailto:/i, "").replace(/^https?:\/\//i, "");
}
